module.exports = __webpack_public_path__ + "src/assets/img/header_wissen_10_em_green_de.21f85f7e.png";